import { render, staticRenderFns } from "./WidgetWrapper.vue?vue&type=template&id=afa65536&scoped=true"
import script from "./WidgetWrapper.vue?vue&type=script&lang=js"
export * from "./WidgetWrapper.vue?vue&type=script&lang=js"
import style0 from "./WidgetWrapper.vue?vue&type=style&index=0&id=afa65536&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa65536",
  null
  
)

export default component.exports